import { Message } from "@cohesive/api-client";

/**
 * Collate a raw flow-message list for rendering: keep user/assistant/assistant-tool-call
 * messages, stitch each tool result back onto its originating tool call, and drop the
 * standalone tool messages. Shared by the main `ChatHistory` and the canvas composer's
 * compact history so the tool-result stitching stays single-sourced.
 */
export function parseMessageHistory(messages: Message[]): Message[] {
  return messages
    .map((message, index, allMessages) => {
      switch (message.origin) {
        case "user":
        case "assistant":
          return message;
        case "assistant-tool-call": {
          // Apply the results of the tool messages that follow this tool call
          // back onto the matching tool_calls entries.
          let nextIndex = index + 1;
          while (
            nextIndex < allMessages.length &&
            allMessages[nextIndex]?.origin === "tool"
          ) {
            const toolMessage = allMessages[nextIndex];

            if (toolMessage) {
              message.tool_calls?.forEach((toolCall) => {
                if (
                  toolMessage.tool_call_id === toolCall.id &&
                  toolMessage.result
                ) {
                  toolCall.result = toolMessage.result;
                }
              });
            }

            nextIndex++;
          }

          return message;
        }

        default:
          return undefined;
      }
    })
    .filter(Boolean) as Message[];
}
